import {LitElement} from 'lit';
import {html} from 'lit/html.js';

import css from './tt-game-row.pcss';

import './../tt-team-name/tt-team-name'
import './../tt-wappen/tt-wappen'

import '@polymer/iron-icon'

import * as dayjs from 'dayjs'

export default class TTGameRow extends LitElement {
    static get properties() {
        return {
            game: {
                type: Object
            },
            displayTime: Boolean
        };
    }

    static get styles() {
        return [css];
    }


    render() {
        return html`
<tt-team-name class="team home twoLines" .team=${this.game.home} .number=${this.game.homeNumber}></tt-team-name>
<tt-wappen class="icon" .team=${this.game.home} size="64x64"></tt-wappen>
<div class="score ${this.scoreState(this.game.state)}">${this._scoreOrStart(this.game)}</div>
<tt-wappen class="icon" .team=${this.game.away} size="64x64"></tt-wappen>
<tt-team-name class="team away twoLines" .team=${this.game.away} .number=${this.game.awayNumber}></tt-team-name>
`;
    }

    firstUpdated(changedProperties) {
        this.addEventListener('click', this.handleClick);
    }

    scoreState(state) {
        switch (state) {
            case "ONGOING":
                return "ONGOING";
            case "SCHEDULED":
                return "SCHEDULED";
        }
        return "";
    }

    _scoreOrStart(game) {
        switch (game.state) {
            case "CANCELED":
                return html`<iron-icon icon="info-outline"></iron-icon>`;

            case "SCHEDULED":
                let gameStart = dayjs(game.start)
                let showTime = this.displayTime || gameStart.isSame(dayjs(), 'day');

                if (showTime) {
                    return gameStart
                        .format('LT');
                } else {
                    return gameStart
                        .format('D.MM');
                }
            default:
                return game.score;
        }
    }

    /* keep */
    handleClick(evt) {
        this.dispatchEvent(new CustomEvent('game-selected', {
            detail: {game: this.game},
            composed: true,
            bubbles: true
        }));
    }

}

window.customElements.define('tt-game-row', TTGameRow);
